import { AxiosResponse } from "axios"
import { useMutation } from "react-query"

import contentService from "api/contentService"
import { LANGS } from "types/shared"
import { IUpdateClientKeywordsBodyParams } from "types/content"
import { useUI } from "providers/UIProvider"
import { RESPONSE_MODAL_VARIANTS } from "components/shared/modals/ResponseModal/ResponseModalTypes"
import { toast } from "react-toastify"

interface IUseUpdateClientKeywords {
  lang: LANGS,
  data: IUpdateClientKeywordsBodyParams
} 

const useUpdateClientKeywords = () => {
  const { toggleModal } = useUI()
  return useMutation(async ({ lang, data }: IUseUpdateClientKeywords) => {
      const res: AxiosResponse<any> = await contentService.updateClientKeywords(lang, data)

      return res.data
  }, {
    onSuccess: () => {
      toggleModal("responseModal", true, { variant: RESPONSE_MODAL_VARIANTS.SUCCESS })
      setTimeout(()=>toggleModal("responseModal", false), 3000)
    },
    onError: () => {
      toast.error("Internal Server Error")
    }
  })
}

export default useUpdateClientKeywords